import { render } from "./feedback-practive.vue?vue&type=template&id=17e2b480&ts=true"
import script from "./feedback-practive.vue?vue&type=script&lang=ts"
export * from "./feedback-practive.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__